import { Command as CommandPrimitive } from 'cmdk'
import type React from 'react'
import { cn } from '@/src/utils/styles'

export const Group = ({
  className,
  ...props
}: React.ComponentPropsWithoutRef<typeof CommandPrimitive.Group>) => (
  <CommandPrimitive.Group
    className={cn(
      'overflow-hidden p-0 text-foreground',
      '[&_[cmdk-group-heading]]:p-4 [&_[cmdk-group-heading]]:text-sm [&_[cmdk-group-heading]]:font-normal [&_[cmdk-group-heading]]:leading-6 [&_[cmdk-group-heading]]:text-secondary',
      className,
    )}
    cmdk-group-wrapper=''
    {...props}
  />
)
